import type { Plan } from "./types";

export function productTitle(plan: Plan) {
  if (plan.productTitle !== undefined) return plan.productTitle;
  return plan.period && plan.title.endsWith(" " + plan.period)
    ? plan.title.slice(0, -plan.period.length).trim()
    : plan.title;
}

export function stockLabel(plan: Plan) {
  if (!plan.inStock) return "已售罄";
  if (plan.stockQuantityHidden || (plan.stockDisplayMode && plan.stockDisplayMode !== "exact"))
    return plan.stockStatus === "low_stock" ? "库存紧张" : "有货";
  return `${plan.availableStock} 份`;
}

export function deliveryLabel(plan: Plan) {
  const type = plan.fulfillmentType || plan.deliveryMode;
  if (type === "auto" || type === "card-key")
    return "自动发货 · 订单内查看交付内容";
  if (type === "manual")
    return "人工交付";
  if (type === "upstream")
    return "上游交付";
  return "";
}
